// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@guestsupply/App/SharedStyles/CartLineSharedStyles";
import { cardStyles } from "@guestsupply/Overrides/Widgets/InvoiceDetails/InvoiceDetailsLineCard";
import { mergeWithCss, xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

cardStyles.cartLineContainer = {
    container: {
        css: css`
            grid-template-columns: 0.5fr 1.5fr 1fr 1fr 1fr 1fr;
        `,
    },
    total: {
        css: css`
            grid-column: 6 / 7;
            ${xScreen("lte", "md")} {
                grid-row: 4 / 5;
                grid-column: 5 / 7;
            }
            @media print {
                min-width: 15%;
            }
        `,
    },
    surcharges: {
        css: css`
            ${xScreen("lte", "md")} {
                grid-row: 4 / 5;
                grid-column: 3 / 5;
            }
            @media print {
                min-width: 15%;
                min-height: 50px;
                float: left;
            }
        `,
    },
};
cardStyles.productDescriptionText = {
    ...cartLineSharedStyles.productDescription?.productDetailDescription,
};

cardStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

cardStyles.productNameLink = {
    ...cartLineSharedStyles.productDescription?.productDetailLink,
};

cardStyles.totalStyles = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
};

cardStyles.subtotalWithoutVatHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
};

cardStyles.qtyLabel = {
    ...cartLineSharedStyles.qtyLabel,
};

cardStyles.image = {
    ...cartLineSharedStyles.productImage?.linkWrappingImage,
};

cardStyles.priceHeading = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.heading,
};

cardStyles.priceText = {
    ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.text, {
        css: css`
            display: inline-flex;
            width: auto;
        `,
    }),
};

cardStyles.unitOfMeasure = {
    ...mergeWithCss(cartLineSharedStyles.unitOfMeasure, {
        css: css`
            display: inline-flex;
            line-height: 17px;
            margin-left: 4px;
        `,
    }),
};

cardStyles.surchargesHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

cardStyles.discountAmountHeadingAndText = {
    ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceText, {
        extendedStyles: {
            wrapper: {
                css: css`
                    padding-top: 5px;
                    gap: 8px;
                    ${xScreen("lte", "md")} {
                        margin-bottom: 8px;
                    }
                `,
            },
            heading: {
                css: css`
                    display: block;
                `,
            },
            text: {
                css: css`
                    ${xScreen("lte", "md")} {
                        padding-top: 0;
                    }
                `,
            },
        },
    }),   
};
